import {mapProgressDbToType, Progress} from '@cp/model';
import {onSnapshot} from 'firebase/firestore';
import getProgressDocRef from './getProgressDocRef';
import {undefinedIfThrowSync} from '@coolcolduk/util';

export default function subscribeProgressDoc(
  uid: string,
  examModuleId: string,
  onData: (progress: Progress | undefined) => void,
  onError?: (err: Error) => void,
): () => void {
  const ref = getProgressDocRef(uid, examModuleId);
  return onSnapshot(
    ref,
    (snap) => {
      onData(undefinedIfThrowSync(() => mapProgressDbToType(snap)));
    },
    (err) => onError?.(err),
  );
}
